import React, {ChangeEvent} from 'react'
import styled from 'styled-components'
import {
    WerfenColor,
    White
} from '../../Constants/ColorChart';

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`

const Icon = styled.svg`
  fill: none;
  stroke: ${WerfenColor};
  stroke-width: 3px;
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 24px;
  height: 24px;
  background: ${White}
  border-radius: 3px;
  transition: all 150ms;
  margin-right: 10px;

  ${HiddenCheckbox}:focus + & {
    outline: none;
  }

  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')}
  }
`

type LoginCheckboxProps = {
    className?: string;
    checked: boolean;
    handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const LoginCheckbox: React.FC<LoginCheckboxProps> = ({ className, checked, handleChange }) => {
    return (
        <CheckboxContainer className={className}>
            <HiddenCheckbox checked={checked} onChange={handleChange}/>
            <StyledCheckbox checked={checked}>
                <Icon viewBox="0 0 24 24">
                    <polyline points="20 6 9 17 4 12" />
                </Icon>
            </StyledCheckbox>
        </CheckboxContainer>
    );
};

export default LoginCheckbox;
